var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHajjIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149282",
    "data-name": "Rectangle 149282",
    width: 175,
    height: 175,
    rx: 87.5,
    transform: "translate(450 4025.211)",
    fill: "#a4a7b0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HajjIllustration",
    transform: "translate(-450 -4025.211)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149280",
    "data-name": "Rectangle 149280",
    width: 175,
    height: 175,
    rx: 87.5,
    transform: "translate(450 4025.211)",
    fill: "#f5f7fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14709",
    "data-name": "Group 14709",
    transform: "translate(441.623 3998.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14577",
    "data-name": "Group 14577",
    transform: "translate(-2.741 70.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14556",
    "data-name": "Group 14556",
    transform: "translate(120.052 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14555",
    "data-name": "Group 14555"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149250",
    "data-name": "Rectangle 149250",
    width: 16.517,
    height: 22.7,
    transform: "translate(17.987 37.841) rotate(180)",
    fill: "#6c568c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14554",
    "data-name": "Group 14554",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14553",
    "data-name": "Group 14553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14552",
    "data-name": "Group 14552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24404",
    "data-name": "Path 24404",
    d: "M300.659,113.447a5.386,5.386,0,0,1-1.325,3.032H282.551a5.374,5.374,0,0,1-1.322-3.032,4.3,4.3,0,0,1,.046-1.063,4.77,4.77,0,0,1,.459-1.377,7.617,7.617,0,0,1,2.087-2.453c1.7-1.376,3.065-2.447,4.13-3.266,2.068-1.588,2.992-2.213,2.992-2.213s.924.623,2.992,2.213c1.065.817,2.431,1.891,4.13,3.266a9.846,9.846,0,0,1,.84.759q.151.15.283.3c.044.052.088.1.132.153a6.824,6.824,0,0,1,.549.74,5.277,5.277,0,0,1,.285.5,4.7,4.7,0,0,1,.457,1.377A4.406,4.406,0,0,1,300.659,113.447Z",
    transform: "translate(-281.215 -103.075)",
    fill: "#6c568c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14561",
    "data-name": "Group 14561",
    transform: "translate(89.629 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14560",
    "data-name": "Group 14560"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149251",
    "data-name": "Rectangle 149251",
    width: 16.517,
    height: 22.7,
    transform: "translate(17.987 37.841) rotate(180)",
    fill: "#6c568c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14559",
    "data-name": "Group 14559",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14558",
    "data-name": "Group 14558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14557",
    "data-name": "Group 14557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24405",
    "data-name": "Path 24405",
    d: "M237.449,113.447a5.384,5.384,0,0,1-1.324,3.032H219.341a5.374,5.374,0,0,1-1.322-3.032,4.262,4.262,0,0,1,.046-1.063,4.782,4.782,0,0,1,.459-1.377,7.622,7.622,0,0,1,2.087-2.453c1.7-1.376,3.066-2.447,4.13-3.266,2.068-1.588,2.992-2.213,2.992-2.213s.924.623,2.992,2.213c1.064.817,2.431,1.891,4.13,3.266a9.755,9.755,0,0,1,.84.759q.151.15.283.3c.044.052.088.1.132.153a6.773,6.773,0,0,1,.549.74,5.4,5.4,0,0,1,.285.5,4.7,4.7,0,0,1,.457,1.377A4.384,4.384,0,0,1,237.449,113.447Z",
    transform: "translate(-218.004 -103.075)",
    fill: "#6c568c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14566",
    "data-name": "Group 14566",
    transform: "translate(58.902 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14565",
    "data-name": "Group 14565"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149252",
    "data-name": "Rectangle 149252",
    width: 16.517,
    height: 22.7,
    transform: "translate(17.987 37.841) rotate(180)",
    fill: "#6c568c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14564",
    "data-name": "Group 14564",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14563",
    "data-name": "Group 14563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24406",
    "data-name": "Path 24406",
    d: "M173.607,113.447a5.386,5.386,0,0,1-1.325,3.032H155.5a5.374,5.374,0,0,1-1.322-3.032,4.307,4.307,0,0,1,.046-1.063,4.767,4.767,0,0,1,.459-1.377,7.615,7.615,0,0,1,2.087-2.453c1.7-1.376,3.065-2.447,4.13-3.266,2.068-1.588,2.992-2.213,2.992-2.213s.924.623,2.992,2.213c1.065.817,2.431,1.891,4.13,3.266a9.838,9.838,0,0,1,.84.759q.151.15.283.3c.044.052.088.1.132.153a6.833,6.833,0,0,1,.549.74,5.29,5.29,0,0,1,.285.5,4.7,4.7,0,0,1,.457,1.377A4.409,4.409,0,0,1,173.607,113.447Z",
    transform: "translate(-154.162 -103.075)",
    fill: "#6c568c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14571",
    "data-name": "Group 14571",
    transform: "translate(28.175 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14570",
    "data-name": "Group 14570"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149253",
    "data-name": "Rectangle 149253",
    width: 16.517,
    height: 22.7,
    transform: "translate(17.987 37.841) rotate(180)",
    fill: "#6c568c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14569",
    "data-name": "Group 14569",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14568",
    "data-name": "Group 14568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14567",
    "data-name": "Group 14567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24407",
    "data-name": "Path 24407",
    d: "M109.764,113.447a5.384,5.384,0,0,1-1.324,3.032H91.656a5.374,5.374,0,0,1-1.322-3.032,4.263,4.263,0,0,1,.046-1.063,4.782,4.782,0,0,1,.459-1.377,7.621,7.621,0,0,1,2.087-2.453c1.7-1.376,3.065-2.447,4.13-3.266,2.068-1.588,2.992-2.213,2.992-2.213s.924.623,2.992,2.213c1.064.817,2.431,1.891,4.13,3.266a9.767,9.767,0,0,1,.84.759q.151.15.283.3c.044.052.088.1.132.153a6.78,6.78,0,0,1,.549.74,5.4,5.4,0,0,1,.285.5,4.7,4.7,0,0,1,.457,1.377A4.384,4.384,0,0,1,109.764,113.447Z",
    transform: "translate(-90.319 -103.075)",
    fill: "#6c568c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14576",
    "data-name": "Group 14576",
    transform: "translate(0 7.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14575",
    "data-name": "Group 14575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24408",
    "data-name": "Path 24408",
    d: "M47.215,134.53v22.7H31.78a74.187,74.187,0,0,1,9.857-22.7Z",
    transform: "translate(-31.78 -126.56)",
    fill: "#6c568c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14574",
    "data-name": "Group 14574",
    transform: "translate(11.036)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14573",
    "data-name": "Group 14573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14572",
    "data-name": "Group 14572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24409",
    "data-name": "Path 24409",
    d: "M60.567,121.175a5.374,5.374,0,0,1-1.328,3.027H54.71a69.825,69.825,0,0,1,4.89-6.233c.063.087.12.173.178.26.106.168.2.337.284.5a4.745,4.745,0,0,1,.457,1.381A4.458,4.458,0,0,1,60.567,121.175Z",
    transform: "translate(-54.71 -117.97)",
    fill: "#6c568c"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14578",
    "data-name": "Group 14578",
    transform: "translate(-5.384 108.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24410",
    "data-name": "Path 24410",
    d: "M285.737,182.333c-.007.592-.029,1.187-.07,1.783-.71,10.6-6.542,21.306-18.849,31.415q-1.643,1.352-3.442,2.688-3.155,2.344-6.123,4.67a246.337,246.337,0,0,0-42.06,41.563H37.934c-10.568-25.623-14.9-54.4-8.969-80.336.136-.6.276-1.191.427-1.783Z",
    transform: "translate(-43.754 -188.444)",
    fill: "#ded5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149254",
    "data-name": "Rectangle 149254",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(66.822 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149255",
    "data-name": "Rectangle 149255",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(162.862 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24411",
    "data-name": "Path 24411",
    d: "M423.961,214.662v8.151q-1.359,1.118-2.846,2.223-2.608,1.938-5.062,3.861h-6.5V214.662a7.206,7.206,0,1,1,14.411,0Z",
    transform: "translate(-225.087 -195.365)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149256",
    "data-name": "Rectangle 149256",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(87.375 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149257",
    "data-name": "Rectangle 149257",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(107.703 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149258",
    "data-name": "Rectangle 149258",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(128.031 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149259",
    "data-name": "Rectangle 149259",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(46.494 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149260",
    "data-name": "Rectangle 149260",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(26.166 12.091)",
    fill: "#5d4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149261",
    "data-name": "Rectangle 149261",
    d: "M7.206,0h0a7.206,7.206,0,0,1,7.206,7.206V21.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.206A7.206,7.206,0,0,1,7.206,0Z",
    transform: "translate(5.838 12.091)",
    fill: "#5d4677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14589",
    "data-name": "Group 14589",
    transform: "translate(75.961 91.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14582",
    "data-name": "Group 14582",
    transform: "translate(-0.001 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14579",
    "data-name": "Group 14579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24412",
    "data-name": "Path 24412",
    d: "M277.361,149.718v78.39H207.606v-78.39a3.1,3.1,0,0,1,3.1-3.1h63.564A3.1,3.1,0,0,1,277.361,149.718Z",
    transform: "translate(-207.606 -146.623)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14580",
    "data-name": "Group 14580",
    transform: "translate(49.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24413",
    "data-name": "Path 24413",
    d: "M330.36,149.718v78.39H309.783V146.623h17.482A3.1,3.1,0,0,1,330.36,149.718Z",
    transform: "translate(-309.783 -146.623)",
    fill: "#392b49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14581",
    "data-name": "Group 14581",
    transform: "translate(0 7.985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149262",
    "data-name": "Rectangle 149262",
    width: 69.755,
    height: 7.088,
    fill: "#dda038"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14583",
    "data-name": "Group 14583",
    transform: "translate(-0.001 17.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149263",
    "data-name": "Rectangle 149263",
    width: 13.532,
    height: 2.146,
    fill: "#dda038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14584",
    "data-name": "Group 14584",
    transform: "translate(17.806 17.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149264",
    "data-name": "Rectangle 149264",
    width: 13.532,
    height: 2.146,
    fill: "#dda038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14585",
    "data-name": "Group 14585",
    transform: "translate(49.177 17.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149265",
    "data-name": "Rectangle 149265",
    width: 8.824,
    height: 2.146,
    fill: "#dd7c33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14586",
    "data-name": "Group 14586",
    transform: "translate(60.93 17.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149266",
    "data-name": "Rectangle 149266",
    width: 8.824,
    height: 2.146,
    fill: "#dd7c33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14587",
    "data-name": "Group 14587",
    transform: "translate(35.717 17.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149267",
    "data-name": "Rectangle 149267",
    width: 13.532,
    height: 2.146,
    fill: "#dda038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14588",
    "data-name": "Group 14588",
    transform: "translate(54.305 24.521)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149268",
    "data-name": "Rectangle 149268",
    width: 10.321,
    height: 9.538,
    fill: "#dda038"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14617",
    "data-name": "Group 14617",
    transform: "translate(2.614 146.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14598",
    "data-name": "Group 14598",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14590",
    "data-name": "Group 14590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24414",
    "data-name": "Path 24414",
    d: "M42.916,314.739H62.264V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-42.916 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14591",
    "data-name": "Group 14591",
    transform: "translate(19.348 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24415",
    "data-name": "Path 24415",
    d: "M83.116,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-83.116 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14592",
    "data-name": "Group 14592",
    transform: "translate(38.696)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24416",
    "data-name": "Path 24416",
    d: "M123.316,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-123.316 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14593",
    "data-name": "Group 14593",
    transform: "translate(58.044 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24417",
    "data-name": "Path 24417",
    d: "M163.516,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-163.516 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14594",
    "data-name": "Group 14594",
    transform: "translate(77.393 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24418",
    "data-name": "Path 24418",
    d: "M203.716,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-203.716 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14595",
    "data-name": "Group 14595",
    transform: "translate(96.741 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24419",
    "data-name": "Path 24419",
    d: "M243.916,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-243.916 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14596",
    "data-name": "Group 14596",
    transform: "translate(116.089 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24420",
    "data-name": "Path 24420",
    d: "M284.116,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-284.116 -277.727)",
    fill: "#6c568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14597",
    "data-name": "Group 14597",
    transform: "translate(135.437 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(2.939)",
    fill: "#6c568c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24421",
    "data-name": "Path 24421",
    d: "M324.316,314.739h19.348V302.327a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-324.316 -277.727)",
    fill: "#6c568c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14607",
    "data-name": "Group 14607",
    transform: "translate(9.523 8.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14599",
    "data-name": "Group 14599",
    transform: "translate(0 1.798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 1.947, 13.297)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24422",
    "data-name": "Path 24422",
    d: "M62.7,349.566H82.051V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-62.703 -301.191)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14600",
    "data-name": "Group 14600",
    transform: "translate(19.348 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 6.736,
    cy: 6.736,
    r: 6.736,
    transform: "translate(0.149 9.526) rotate(-45)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24423",
    "data-name": "Path 24423",
    d: "M102.9,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-102.903 -299.392)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14601",
    "data-name": "Group 14601",
    transform: "translate(38.696 1.416)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_400",
    "data-name": "Ellipse 400",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.564 13.106) rotate(-76.636)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24424",
    "data-name": "Path 24424",
    d: "M143.1,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-143.103 -300.808)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14602",
    "data-name": "Group 14602",
    transform: "translate(58.044 1.794)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.943 13.296) rotate(-80.742)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24425",
    "data-name": "Path 24425",
    d: "M183.3,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-183.303 -301.187)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14603",
    "data-name": "Group 14603",
    transform: "translate(77.393 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    cx: 6.736,
    cy: 6.736,
    r: 6.736,
    transform: "translate(0.149 9.526) rotate(-45)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24426",
    "data-name": "Path 24426",
    d: "M223.5,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-223.503 -299.393)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14604",
    "data-name": "Group 14604",
    transform: "translate(96.741 1.416)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_403",
    "data-name": "Ellipse 403",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.564 13.106) rotate(-76.636)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24427",
    "data-name": "Path 24427",
    d: "M263.7,349.566h19.349V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-263.703 -300.808)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14605",
    "data-name": "Group 14605",
    transform: "translate(116.089 1.794)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.942 13.296) rotate(-80.742)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24428",
    "data-name": "Path 24428",
    d: "M303.9,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-303.904 -301.187)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14606",
    "data-name": "Group 14606",
    transform: "translate(135.438 0.088)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(0.237 8.143) rotate(-37.191)",
    fill: "#49365b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24429",
    "data-name": "Path 24429",
    d: "M344.1,349.566h19.348V326.782a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-344.104 -299.481)",
    fill: "#49365b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14616",
    "data-name": "Group 14616",
    transform: "translate(0 28.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14608",
    "data-name": "Group 14608",
    transform: "translate(0 1.423)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_406",
    "data-name": "Ellipse 406",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.571 13.111) rotate(-76.718)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24430",
    "data-name": "Path 24430",
    d: "M42.916,411.367H62.264V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-42.916 -342.082)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14609",
    "data-name": "Group 14609",
    transform: "translate(19.348 0.008)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(0.157 9.906) rotate(-47.337)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24431",
    "data-name": "Path 24431",
    d: "M83.116,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-83.116 -340.667)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14610",
    "data-name": "Group 14610",
    transform: "translate(38.696 0.748)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "matrix(0.926, -0.377, 0.377, 0.926, 0.897, 5.076)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24432",
    "data-name": "Path 24432",
    d: "M123.316,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-123.316 -341.408)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14611",
    "data-name": "Group 14611",
    transform: "translate(58.044 1.405)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.553 13.1) rotate(-76.51)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24433",
    "data-name": "Path 24433",
    d: "M163.516,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-163.516 -342.064)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14612",
    "data-name": "Group 14612",
    transform: "translate(77.393 0.003)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(0.151 9.305) rotate(-43.685)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24434",
    "data-name": "Path 24434",
    d: "M203.716,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-203.716 -340.662)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14613",
    "data-name": "Group 14613",
    transform: "translate(96.741 0.712)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(0.861 5.2) rotate(-22.704)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24435",
    "data-name": "Path 24435",
    d: "M243.916,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-243.916 -341.371)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14614",
    "data-name": "Group 14614",
    transform: "translate(116.089 1.43)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 6.736,
    cy: 6.736,
    rx: 6.736,
    ry: 6.736,
    transform: "translate(1.578 13.115) rotate(-76.798)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24436",
    "data-name": "Path 24436",
    d: "M284.116,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-284.116 -342.089)",
    fill: "#3a2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14615",
    "data-name": "Group 14615",
    transform: "translate(135.437 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_413",
    "data-name": "Ellipse 413",
    cx: 6.736,
    cy: 6.736,
    r: 6.736,
    transform: "translate(0.149 9.526) rotate(-45)",
    fill: "#3a2c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24437",
    "data-name": "Path 24437",
    d: "M324.316,411.367h19.348V368.049a9.674,9.674,0,0,0-9.674-9.674h0a9.674,9.674,0,0,0-9.674,9.674Z",
    transform: "translate(-324.316 -340.659)",
    fill: "#3a2c4c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14641",
    "data-name": "Group 14641",
    transform: "translate(33.146 90.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14618",
    "data-name": "Group 14618",
    transform: "translate(10.436 109.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24438",
    "data-name": "Path 24438",
    d: "M98.429,542.9c-.377,7.229-.714,13.9-.714,14.629,1.637,3.1.62,5.021-1.975,5.021H81.69s-.339-3.221,2.569-3.221c4.176-.216,7.477-5.4,7.477-5.4l-.925-10.205L89.747,531.98l-.489-5.409,10.187-2.825s-.194,3.607-.452,8.465C98.82,535.45,98.62,539.245,98.429,542.9Z",
    transform: "translate(-81.678 -523.746)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14619",
    "data-name": "Group 14619",
    transform: "translate(37.82 109.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24439",
    "data-name": "Path 24439",
    d: "M187.132,562.546h-14.05c-2.6,0-3.611-1.919-1.974-5.021,0-.824-.438-9.372-.875-17.663-.135-2.566-.269-5.107-.389-7.386h0c-.265-4.992-.466-8.73-.466-8.73l10.187,2.825-.556,6.137-.308,3.4-1.613,17.82s3.3,5.179,7.477,5.4C187.47,559.325,187.132,562.546,187.132,562.546Z",
    transform: "translate(-169.377 -523.746)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14620",
    "data-name": "Group 14620",
    transform: "translate(18.504 117.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24440",
    "data-name": "Path 24440",
    d: "M107.519,550.115l9.246.231c-.173,3.239-.374,7.033-.565,10.685a63.9,63.9,0,0,1-7.618.828Z",
    transform: "translate(-107.519 -550.115)",
    fill: "#ad6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14621",
    "data-name": "Group 14621",
    transform: "translate(38.287 117.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24441",
    "data-name": "Path 24441",
    d: "M180.037,551.936l-.308,3.4a65.837,65.837,0,0,1-8.467,3.752c-.135-2.566-.269-5.107-.389-7.386Z",
    transform: "translate(-170.873 -551.705)",
    fill: "#ad6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14622",
    "data-name": "Group 14622",
    transform: "translate(44.458 30.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24442",
    "data-name": "Path 24442",
    d: "M231.81,274.525s-4.961,3.284-9.992,3.7c0,0-1.464,1.276-3.617,2.979-.756.6-1.6,1.249-2.49,1.916-.382.284-.773.573-1.17.862-4.038,2.925-8.771,5.855-11.447,5.78-5.31-.148-12.458-5.395-12.458-5.395l4.058-11.688c4.137,2.681,9.517,8.55,9.517,8.55a123.821,123.821,0,0,1,11.5-4.821,28.918,28.918,0,0,1,5.968-1.537A77.541,77.541,0,0,1,231.81,274.525Z",
    transform: "translate(-190.637 -272.681)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14623",
    "data-name": "Group 14623",
    transform: "translate(68.362 34.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24443",
    "data-name": "Path 24443",
    d: "M270.851,289.422c-.756.6-1.6,1.249-2.49,1.916-.382.284-.772.573-1.17.861l1.17-7.573Z",
    transform: "translate(-267.191 -284.626)",
    fill: "#ad6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14624",
    "data-name": "Group 14624",
    transform: "translate(41.495 27.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24444",
    "data-name": "Path 24444",
    d: "M209.185,268.674v15.4a15.915,15.915,0,0,1-15.916,15.915H181.148V261.432h0a22.231,22.231,0,0,1,7.019,3.51v0c4.137,2.681,9.517,8.55,9.517,8.55A123.83,123.83,0,0,1,209.185,268.674Z",
    transform: "translate(-181.148 -261.432)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14625",
    "data-name": "Group 14625",
    transform: "translate(2.668 30.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24445",
    "data-name": "Path 24445",
    d: "M67.3,272.672c-5.339,3.858-8.505,9.983-10.083,13.851a5.666,5.666,0,0,0,1.195,6.1l13.031,13.35,1.688-4.016-7.5-13.51,8.341-7.226Z",
    transform: "translate(-56.803 -272.672)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14626",
    "data-name": "Group 14626",
    transform: "translate(13.17 26.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24446",
    "data-name": "Path 24446",
    d: "M125.78,262.869l-6.786,19.549H97.22l-.955-2.753-5.831-16.8a22.712,22.712,0,0,1,13.571-4.448l4.033,0h.138l4.033,0c.148,0,.3,0,.442,0A22.743,22.743,0,0,1,125.78,262.869Z",
    transform: "translate(-90.434 -258.418)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14634",
    "data-name": "Group 14634",
    transform: "translate(23.879 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14627",
    "data-name": "Group 14627",
    transform: "translate(1.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24447",
    "data-name": "Path 24447",
    d: "M139.853,210.146h-9.435l-.853-4.752a5.145,5.145,0,0,1,5.076-6.119h.989c.06,0,.12,0,.18,0a5.212,5.212,0,0,1,4.889,6.156Z",
    transform: "translate(-129.481 -199.275)",
    fill: "#49365b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14633",
    "data-name": "Group 14633",
    transform: "translate(0 3.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14628",
    "data-name": "Group 14628",
    transform: "translate(0 4.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24448",
    "data-name": "Path 24448",
    d: "M127.258,225.99c-1.032-1.969-2.655-2.211-2.517-.415s2.21,2.857,2.867,2.154-.644-1.739-.644-1.739",
    transform: "translate(-124.733 -224.36)",
    fill: "#aa6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14629",
    "data-name": "Group 14629",
    transform: "translate(10.919 4.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24449",
    "data-name": "Path 24449",
    d: "M160.236,225.99c1.031-1.969,2.655-2.211,2.516-.415s-2.21,2.857-2.866,2.154.644-1.739.644-1.739",
    transform: "translate(-159.7 -224.36)",
    fill: "#aa6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14630",
    "data-name": "Group 14630",
    transform: "translate(2.862 7.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24450",
    "data-name": "Path 24450",
    d: "M142.242,242.825a4.558,4.558,0,0,1-8.344,0A1.17,1.17,0,0,0,134.9,241.8l.036-.313.636-5.436.036-.31h4.916l.267,2.282.061.525.38,3.248a1.168,1.168,0,0,0,1.006,1.024Z",
    transform: "translate(-133.898 -235.745)",
    fill: "#c18080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14631",
    "data-name": "Group 14631",
    transform: "translate(3.904 7.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24451",
    "data-name": "Path 24451",
    d: "M143.15,239.235a14.6,14.6,0,0,1-5.916,2.939l.636-5.436,5.219,1.972Z",
    transform: "translate(-137.234 -236.738)",
    fill: "#aa6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14632",
    "data-name": "Group 14632",
    transform: "translate(2.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24452",
    "data-name": "Path 24452",
    d: "M139.119,211.411a2.345,2.345,0,0,1,2.345,2.345v4.322a4.82,4.82,0,0,1-1.416,3.424,4.363,4.363,0,0,1-6.8,0,4.82,4.82,0,0,1-1.416-3.424v-4.322a2.344,2.344,0,0,1,2.344-2.345h0a2.841,2.841,0,0,0,4.942,0Z",
    transform: "translate(-131.833 -211.411)",
    fill: "#c18080"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14635",
    "data-name": "Group 14635",
    transform: "translate(19.001 26.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24453",
    "data-name": "Path 24453",
    d: "M138.624,262.872l-4.058,11.691-2.729,7.859H110.064l-.955-2.753c3.62-3.444,14.337-14.083,16.385-21.247a21.476,21.476,0,0,1,6.109.94h0A22.231,22.231,0,0,1,138.624,262.872Z",
    transform: "translate(-109.109 -258.422)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14636",
    "data-name": "Group 14636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24454",
    "data-name": "Path 24454",
    d: "M69.673,175.288a1.343,1.343,0,0,0-1.344-1.342H49.6a1.343,1.343,0,0,0-1.344,1.342v14.147A1.345,1.345,0,0,0,49.6,190.78H68.329a1.344,1.344,0,0,0,1.344-1.344Z",
    transform: "translate(-48.258 -173.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24455",
    "data-name": "Path 24455",
    d: "M68.528,186.395a2.993,2.993,0,0,1,2.87,1.674,2.994,2.994,0,0,1,2.908-1.609c2.232.025,4.49,3.6-3,9.685C63.957,189.889,66.3,186.37,68.528,186.395Z",
    transform: "translate(-60.681 -182.507)",
    fill: "#dda038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24456",
    "data-name": "Path 24456",
    d: "M94.74,224.184l3.522,3.37v-4.367Z",
    transform: "translate(-80.226 -207.812)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14637",
    "data-name": "Group 14637",
    transform: "translate(8.724 50.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24457",
    "data-name": "Path 24457",
    d: "M113.953,350.42h0c-.868-6.7-2.332-12.228-4.681-15.139H87.429C77.691,347.346,76.2,404.3,76.2,404.3c8.075,5.995,30.005,6.531,43.777-1.08C119.975,403.217,118.7,365.558,113.953,350.42Z",
    transform: "translate(-76.198 -335.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14638",
    "data-name": "Group 14638",
    transform: "translate(26.576 50.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24458",
    "data-name": "Path 24458",
    d: "M134.073,337.769v-.684a29.56,29.56,0,0,0,9.757-1.77H133.369v-.684h13.726l-1.355.65A30.093,30.093,0,0,1,134.073,337.769Z",
    transform: "translate(-133.369 -334.631)",
    fill: "#ded5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14639",
    "data-name": "Group 14639",
    transform: "translate(57.828 39.381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149269",
    "data-name": "Rectangle 149269",
    width: 0.684,
    height: 3.669,
    fill: "#ded5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14640",
    "data-name": "Group 14640",
    transform: "translate(11.503 34.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24459",
    "data-name": "Path 24459",
    d: "M90.651,292.922l-2.462-7.093L85.1,297.492Z",
    transform: "translate(-85.096 -285.829)",
    fill: "#ad6d6d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M102.553,244.016C43.64,241.486-16.166,110.195,67.915,65.875s223.178,27.478,154.4,78.54C148.374,199.319,169.12,246.875,102.553,244.016Z",
    transform: "translate(-31.675 -6.199)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24460",
    "data-name": "Path 24460",
    d: "M393.239,130.2a8.105,8.105,0,0,0,4.348-1.26,10.92,10.92,0,1,1,0-13.711,8.117,8.117,0,1,0-4.35,14.97Z",
    transform: "translate(-230.665 -37.685)",
    fill: "#dda038"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHajjIllustration);
export default __webpack_public_path__ + "static/media/HajjIllustration.21a416af8f8153469ca0d4a86f99c9fa.svg";
export { ForwardRef as ReactComponent };